import { LogoutOutlined, SettingOutlined, StarOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Dropdown, MenuProps } from 'antd'
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import accountApi from 'src/component/app/account/AccountApi'
import { useUser } from 'src/context/UserContext'

interface Props { }

export const ProfileMenu: React.FC<Props> = () => {

    const navigateTo = useNavigate()
    const { user } = useUser()

    const logout = () => accountApi.logout().then(success => {
        if (success) navigateTo('/login')
    })

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <div>
                    <StarOutlined />  {user?.role}
                    <br />
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <Link to={`/account/${user?.id}/edit`}>
                    <SettingOutlined />  Edit Profile
                </Link>
            ),
        },
        {
            key: 'logout',
            label: (
                <a onClick={logout}>
                    <LogoutOutlined />  Logout
                </a>
            ),
        },
    ];

    return (
        <div>
            <Dropdown
                menu={{ items }}
                trigger={['click']}
            >
                <Button type="text" className="profile-button" >
                    <img src="/resources/images/profile.svg" alt="" />{user?.email}
                </Button>
            </Dropdown>
        </div>
    )
}

export default ProfileMenu


// WEBPACK FOOTER //
// ./src/component/app/breadcrumb/ProfileMenu.tsx